import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import { toDataURL } from 'qrcode';

import {
  HeroLogo,
  PageTitle,
  StepIndicator,
  CheckIcon,
  ResultContainer,
  CloseIcon,
  Instruction,
  ResultContainerContent,
} from '../components';
import { Stack } from '@mui/material';

const PayButton = styled.button`
  width: 50%;
  padding: 10px;
  margin: 20px auto;
  background-color: #b34cff;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;

  &:hover {
    background-color: #a54cff;
  }
`;

const QRContainer = styled.div`
  margin-bottom: 20px;
`;

export const BpayWechatQrPayment = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const paymentId = query.get('paymentId');

  const qrImage = sessionStorage.getItem('qrCodeImage'); // TODO: Fetch the QR code image from the server based on the paymentId in the request url.
  const [dataURL, setDataURL] = useState('');

  const [paymentStatus, setPaymentStatus] = useState('PAYING');
  const [errorMessage, setErrorMessage] = useState('');
  const intervalRef = useRef(null);

  useEffect(() => {
    const QRText = sessionStorage.getItem('qrCodeImageUrl');
    if (QRText == null) return;
    toDataURL(QRText, { errorCorrectionLevel: 'H' })
      .then((url) => {
        setDataURL(url);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Function to fetch payment status
  const fetchPaymentStatus = useCallback(async () => {
    try {
      const response = await axios.get(`/api/wechat/payment/${paymentId}`);
      const { result_code } = response.data;

      if (result_code === 'PAY_SUCCESS') {
        setPaymentStatus('PAY_SUCCESS');
      } else if (result_code === 'PAYING') {
        setPaymentStatus('PAYING');
      } else if (result_code === 'CLOSED') {
        setPaymentStatus('ERROR');
        setErrorMessage('付款超时。请返回重新提交表单以生成一个新的二维码。');
      } else {
        setPaymentStatus('ERROR');
        setErrorMessage('Payment failed or encountered an error.');
      }

      if (result_code !== 'PAYING') {
        clearInterval(intervalRef.current);
      }
    } catch (error) {
      console.log('Error fetching payment status:', error);
    }
  }, [paymentId]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (paymentStatus === 'PAYING') {
        fetchPaymentStatus();
      }
    }, 3000);

    return () => clearInterval(intervalRef.current);
  }, [fetchPaymentStatus, paymentStatus]);

  const wechatLinktoggleEnabled =
    new URLSearchParams(useLocation().search).get('toggle') === 'wl';

  function handlePayBill() {
    window.location.href = sessionStorage.getItem('qrCodeImageUrl');
  }

  return (
    <ResultContainer>
      <HeroLogo />

      {paymentStatus === 'PAY_SUCCESS' ? (
        <ResultContainerContent>
          <PageTitle>支付结果</PageTitle>
          <StepIndicator step={3} />
          <PageTitle>成功</PageTitle>
          <CheckIcon color="#1AB260" size="100px" />
          <Instruction>您的付款已经完成。</Instruction>
        </ResultContainerContent>
      ) : paymentStatus === 'PAYING' ? (
        <ResultContainerContent>
          <PageTitle>扫描二维码</PageTitle>
          <StepIndicator step={2} />
          <Instruction>
            请使用您的微信应用程序扫描二维码。在显示成功或错误消息之前，请不要退出此页面或返回。
          </Instruction>
          {wechatLinktoggleEnabled && (
            <PayButton onClick={handlePayBill}>Pay in WeChat</PayButton>
          )}
          <QRContainer>
            <img
              src={qrImage || dataURL}
              alt="QR Code"
              style={{ width: '256px', height: '256px' }}
            />
          </QRContainer>
        </ResultContainerContent>
      ) : (
        <ResultContainerContent>
          <PageTitle>支付结果</PageTitle>
          <StepIndicator step={3} />
          <Stack alignItems="center">
            <PageTitle>未完成</PageTitle>
            <Instruction>{errorMessage}</Instruction>
          </Stack>
          <CloseIcon color="#EF454A" size="100px" />
        </ResultContainerContent>
      )}
    </ResultContainer>
  );
};
